<template>
  <div class="col-select-wrap" @click="select($event)" ref="col-select-wrap">
    <div class="overlay"></div>
    <img :src="$images.blueTick" v-if="selectedColumnSet == columnNumber" />
    <div class="col-select" :class="{ selected: selectedColumnSet == columnNumber}">
      <div v-for="(div, idx) in columnNumber" :key="idx"></div>
    </div>
    <span> {{ label }} </span>
  </div>
</template>

<script>
export default {
  props: {
    columnNumber: {
      type: Number,
    },
    label: {
      type: String,
    },
    selectedColumnSet:{
        type:Number
    }
  },
  data() {
    return {
      selectedLayout: null,
    };
  },
  mounted(){
    setTimeout(() => {
      if(this.selectedColumnSet == this.columnNumber) {
        this.$refs['col-select-wrap'].click()
      }
    }, 100);
  },
  methods: {
    select() {
        this.$emit("activeSelect",this.columnNumber)
        this.EventBus.$emit('clearAccordionFields',this.columnNumber)
    },
  },
};
</script>

<style scoped lang='scss'>
.col-select-wrap {
  position: relative;
  height: 90px;
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .col-select {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 150px;
    height: 60px;
    border: 1px solid #cbcbe4;
    padding: 5px;
    margin: 0 0 10px 0;
    cursor: pointer;
    &.selected {
      border-color: #2295d6;
    }
    div {
      background: #cbcbe4;
      flex-basis: 100%;
      text-align: center;
      border: 1px solid #fff;
      height: 100%;
      margin: 0 1px;
    }
  }
  span {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #001529;
  }
  img {
    position: absolute;
    width: 20px;
    left: calc(100% - 10px);
    bottom: calc(100% - 5px);
  }
}
</style>